var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldPenClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.64 22.39c-.65.08-1.23-.02-1.72-.26a2.59 2.59 0 0 1-1.19-1.19c-.24-.49-.33-1.06-.26-1.7l.85-7.15c.08.03.16.06.24.08.61.22 1.26.33 1.94.33 1.46 0 2.87-.53 3.94-1.48a5.962 5.962 0 0 0 2-3.71c.01-.05.01-.1.01-.15l.17.01 6.08 6.09.26 4.42c.25 2.48-.61 3.34-2.96 3.61l-9.36 1.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69 2.99A4.448 4.448 0 0 0 2 6.5c0 .84.24 1.64.65 2.32.44.73 1.08 1.33 1.86 1.71.17.09.36.17.55.23.45.16.93.24 1.44.24 1.14 0 2.17-.42 2.96-1.12a4.455 4.455 0 0 0 1.37-2.18c.06-.2.1-.41.13-.63.03-.19.04-.38.04-.57a4.494 4.494 0 0 0-7.31-3.51zM7.7 8.43c-.19 0-.38-.08-.53-.22l-.66-.66-.68.68c-.15.15-.34.22-.53.22s-.39-.07-.53-.22a.754.754 0 0 1 0-1.06l.69-.69-.67-.65a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.66.66.63-.63c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.63.63.66.66c.3.29.3.76 0 1.06-.14.14-.34.22-.53.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.93 11.592c-.39.24-.89.19-1.21-.14l-4.43-4.43a.982.982 0 0 1-.14-1.21l1.31-2.07c.8-1.26 2.4-1.32 3.59-.15l3.11 3.11c1.09 1.11 1.02 2.83-.16 3.58l-2.07 1.31z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPenClose);
export default __webpack_public_path__ + "static/media/vuesax-bold-pen-close.e0478484962574f2d44821e184a2709b.svg";
export { ForwardRef as ReactComponent };